import { render, staticRenderFns } from "./TaskFields.vue?vue&type=template&id=e49e5fbe"
import script from "./TaskFields.vue?vue&type=script&lang=js"
export * from "./TaskFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports